import React from "react";
import { UserRound, Users } from "lucide-react";
import { RoleEnum } from "../../shared/model/role.enum";
import { useSelector } from "react-redux";
import { selectLoaderValue } from "../../../redux/Slices/loadingSlice";
import Spinner from "../../shared/components/Spinner";
import SocialLogins from "./SocialLogins";
import { useTranslation } from "react-i18next";

const CommonRegisterComponent = ({ handleContinueWithEmail, handleLogin, onSelectUserType, selectedUserType }) => {
    const { t } = useTranslation();
    const isLoading = useSelector(selectLoaderValue);

    return (
        <>
            <p className="text-gray-600 text-sm sm:text-base mb-2 sm:mb-4 text-center">{t("registerPage.iWantTo")}</p>
            <div className="grid grid-cols-2 gap-4">
                <label className="relative group cursor-pointer">
                    <input
                        type="radio"
                        name="userType"
                        value={RoleEnum.client}
                        checked={selectedUserType === RoleEnum.client}
                        onChange={() => onSelectUserType(RoleEnum.client)}
                        className="peer sr-only"
                    />
                    <div
                        className="h-28 flex flex-col items-center justify-center border-2 rounded-xl 
                        hover:border-blue-200 hover:bg-blue-50 peer-checked:border-blue-500 
                        peer-checked:bg-blue-50 transition-all">
                        <UserRound className="h-4 sm:h-6 w-4 sm:w-6 text-blue-600 mb-3" />
                        <div className="px-4 text-center">
                            <span className="text-xs sm:text-sm text-gray-700">{t("registerPage.hireProfessional")}</span>
                        </div>
                    </div>
                </label>
                <label className="relative group cursor-pointer">
                    <input
                        type="radio"
                        name="userType"
                        value={RoleEnum.professional}
                        checked={selectedUserType === RoleEnum.professional}
                        onChange={() => onSelectUserType(RoleEnum.professional)}
                        className="peer sr-only"
                    />
                    <div
                        className="h-28 flex flex-col items-center justify-center border-2 rounded-xl 
                        hover:border-blue-200 hover:bg-blue-50 peer-checked:border-blue-500 
                        peer-checked:bg-blue-50 transition-all">
                        <Users className="h-4 sm:h-6 w-4 sm:w-6 text-blue-600 mb-3" />
                        <div className="px-4 text-center">
                            <span className="text-xs sm:text-sm text-gray-700">{t("registerPage.workAsProfessional")}</span>
                        </div>
                    </div>
                </label>
            </div>
            <div className="space-y-4">
                <SocialLogins role={selectedUserType} />
            </div>
            <p className="text-gray-500 text-xs sm:text-sm mb-2 sm:mb-4 text-center">{t("registerPage.or")}</p>
            <button
                onClick={handleContinueWithEmail}
                className="w-full h-12 bg-blue-600 text-white rounded-lg hover:bg-blue-700 
                    transition-colors font-medium flex items-center justify-center gap-2">
                {isLoading ? (
                    <>
                        <Spinner size={5} />
                        {t("registerPage.loading")}
                    </>
                ) : (
                    t("registerPage.continueWithEmail")
                )}
            </button>
            <p className="text-sm text-gray-600 mt-2 text-center text-xs sm:text-sm">
                {t("registerPage.alreadyHaveAccount")}
                <button onClick={handleLogin} className="text-blue-600 hover:text-blue-800 text-xs sm:text-sm ml-1">
                    {t("registerPage.logIn")}
                </button>
            </p>
        </>
    );
};

export default CommonRegisterComponent;
